<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      title="附件管理"
      class="customer-edit"
      width="800px"
      top="10vh">
    <el-upload
        action=""
        multiple
        :http-request="submitUpload"
        :show-file-list="false"
        :disabled="uploadLoading">
      <el-button type="primary" :loading="uploadLoading" icon="el-icon-upload2">上传附件</el-button>
    </el-upload>
    <el-table :data="accessoryVoList" border style="margin-top: 10px; width: 100%">
      <el-table-column type="index" align="center" label="#" width="55"/>
      <el-table-column prop="fileName" align="left" label="附件名称"/>
      <el-table-column prop="note" align="center" label="备注" width="150"/>
      <el-table-column label="操作" align="center" width="150">
        <template slot-scope="scope">
          <el-button type="primary" size="mini" @click="download(scope.row)">下载</el-button>
          <el-button type="danger" size="mini" @click="deleteFile(scope.$index)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <span slot="footer">
      <el-button @click="dialogVisible=false">关闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import loginUtil from "@/util/loginUtil";

  export default {
    name: "CustomerDeliveryAddressAttachment",
    data() {
      return {
        dialogVisible: false,
        uploadLoading: false,
        pkid: "",
        form: {},
        accessoryVoList: [],
      };
    },
    methods: {
      open(row) {
        this.pkid = row.pkid;
        this.dialogVisible = true;
        this.getData();
      },
      getData() {
        this.$http.get("basic", `customerDeliveryAddress/${this.pkid}`).then(resp => {
          this.form = resp;
          this.accessoryVoList = resp.accessoryVoList || [];
        });
      },
      submitUpload(params) {
        this.uploadLoading = true;
        let formData = new FormData();
        formData.append("files", params.file);
        formData.append("Authorization", loginUtil.getToken());
        this.$http.post("basic", "file/batch/0", formData).then(res => {
          this.uploadLoading = false;
          let attachments = (res && res.data && res.data.attachments) || [];
          for (let item of attachments) {
            this.accessoryVoList.push({
              fileName: item.fileName,
              filePath: item.filePath,
              note: "",
            });
          }
          this.save();
          this.$message.success("上传成功");
        }).catch(() => {
          this.uploadLoading = false;
          this.$message.error("上传失败");
        });
      },
      download(row) {
        let a = document.createElement("a");
        a.href = window.config.fileServerUrl + row.filePath;
        a.target = "_blank";
        a.download = row.filePath;
        a.style.display = "none";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      },
      deleteFile(index) {
        this.$confirm("确定删除该附件吗?", "提示", {type: "warning"}).then(() => {
          this.accessoryVoList.splice(index, 1);
          this.save();
        });
      },
      save() {
        this.form.accessoryVoList = this.accessoryVoList;
        this.$http.put("basic", "customerDeliveryAddress", this.form).then(() => {
          this.$message.success("保存成功");
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
</style>
